import { buildLinkLayer } from "./buildLayer.js";
import { prefixObjectKeys } from "../utils/prefixObjectKeys.js";
export let FormType = /*#__PURE__*/function (FormType) {
  FormType["Calculator"] = "Calculator";
  FormType["Form"] = "Form";
  return FormType;
}({});
const buildFormLayer = buildLinkLayer(props => {
  if ('error' in props) {
    const {
      error,
      ...rest
    } = props;
    return prefixObjectKeys('form_', {
      data_error: error,
      ...rest
    });
  }
  return prefixObjectKeys('form_', props);
});
const buildCalcLayer = buildLinkLayer(props => {
  return prefixObjectKeys('calculator_', props);
});
export const buildAnyFormLayer = (type, props) => {
  switch (type) {
    case FormType.Form:
      return buildFormLayer(props);
    case FormType.Calculator:
      return buildCalcLayer(props);
    default:
      throw new Error('Unknown FormType.');
  }
};